<div class="article-page-wrapper">
  <div class="article-container content-wrapper">
    <div class="wellbeing-header-wrapper">
      <h1 class="title">Student Wellbeing</h1>
      <div class="separator"></div>

      <div class="header-layout">
        <h2 class="article-title">{{ article.title }}</h2>

        <div class="article-meta-data">
          <p>By {{ article.author }}</p>
          <p>Created {{ article.date_published | dateFormat }}.</p>
        </div>
      </div>
    </div>

    <div class="article-body-wrapper">
      <div class="article-body">
        <app-render-markdown
          [content]="article.article_body"
        ></app-render-markdown>
      </div>

      <div class="article-info">
        <p>
          By {{ article.author }}, Created on
          {{ article.date_published | dateFormat }}.
        </p>
      </div>
    </div>
  </div>
</div>
